import React from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";

export const SubNav = () => {};

const SubNavLink = ({ shortName, color, text }) => {
    return (
        <AnchorLink
            href={`#${shortName}`}
            alt={`goto ${shortName}`}
            title={`goto ${shortName}`}
            className="border-bottom"
            style={{ borderColor: color }}
        >
            {text}
        </AnchorLink>
    );
};

export default SubNavLink;
